// extracted by mini-css-extract-plugin
export default {"root":"AppWithHeader_root__Xeut4"};